function directive(generateId, $stateParams, $rootScope, $location, usSpinnerService, $state) {
    return {
        replace: true,
        restrict: "EA",
        scope: true,
        template: require('./view.html'),
        link: function ($scope, element, attrs, ctrl) {
            // select elements
            let elem = element[0],
                input = elem.querySelector('input'),
                hintMenu = elem.querySelector('.hint-menu-container'),
                filtersMenu = elem.querySelector('.filters-container'),
                buttons = elem.querySelector('.filter-controls');

            // filter management
            let filterDropdownBtn = buttons.querySelector('.count');

            // DEFINITIONS
            let keys = {
                up: 38,
                down: 40,
                left: 37,
                right: 39,
                esc: 27,
                back: 8,
                enter: 13,
                shift: 16,
                ctrl: 17,
                alt: 18,
                space: 32,
                tab: 9
            }

            // arrow navigation on the dropdown items
            function modHighlightPosition(arr, command, callback) {
                function checkNext(a, i) {
                    if ((a.length-1) === i) { // we're at the end of the array, nothing here
                        return false;
                    } else {
                        return true;
                    }
                }
                function checkPrev(a, i) {
                    if (i === 0) { // there's nothing before the 0
                        return false;
                    } else {
                        return true;
                    }
                }
                let selected, result;
                // loop through all the list items and children to see if anything has been selected as active yet
                for (let p = 0, plen = arr.length; p < plen; p++) {
                    for (let v = 0, vlen = arr[p].value.length; v < vlen; v++) {
                        if (arr[p].value[v].selected) {
                            selected = [p, v];
                        }
                        if (selected) {
                            break; // stop loop if found something selected
                        }
                    }
                    if (selected) {
                        break; // stop parent loop if found something selected
                    }
                }
                // if selected, change active status
                if (selected) {
                    $scope.hintList[selected[0]].value[selected[1]].selected = false;
                }
                if (command === 'up') {
                    if (selected) {
                        let p = selected[0];
                        let v = selected[1];
                        // check for previous value
                        if (checkPrev(arr[p].value, v)) {
                            // there is previous value
                            result = [p, v-1];
                        } else {
                            // there is not a previous value. check for previous parent
                            if (checkPrev(arr, p)) {
                                // there is a previous parent
                                result = [(p-1), (arr[p-1].value.length-1)];
                            } else {
                                // there is not a previous parent
                                // go to bottom of everything
                                result = [(arr.length-1), (arr[arr.length-1].value.length-1)]
                            }
                        }
                    } else {
                        // go to bottom of the chart
                        let p = arr.length-1;
                        let v = arr[arr.length-1].value.length-1;
                        result = [p, v];
                    }
                } else { // command === 'down'
                    if (selected) {
                        let p = selected[0];
                        let v = selected[1];
                        // check for next value
                        if (checkNext(arr[p].value, v)) {
                            // there is a previous value
                            result = [p, v+1];
                        } else {
                            // there is no next value. check for next parent
                            if (checkNext(arr, p)) {
                                // there is another parent
                                result = [p+1, 0];
                            } else {
                                // there is not another parent
                                // go to top
                                result = [0, 0];
                            }
                        }
                    } else {
                        // just go to the first item in the list
                        result = [0, 0];
                    }
                }
                // set the current selected item
                $scope.hintList[result[0]].value[result[1]].selected = true;
                return callback(result);
            }
            function getSelectedListItem() {
                let selected = false;
                // loop through all the list items and children to see if anything has been selected as active yet
                for (let p = 0, plen = $scope.hintList.length; p < plen; p++) {
                    for (let v = 0, vlen = $scope.hintList[p].value.length; v < vlen; v++) {
                        if ($scope.hintList[p].value[v].selected) {
                            selected = [p, v];
                        }
                        if (selected) {
                            break; // stop loop if found something selected
                        }
                    }
                    if (selected) {
                        break; // stop parent loop if found something selected
                    }
                }
                if (selected) {
                    selected = {
                        item: $scope.hintList[selected[0]].value[selected[1]],
                        parent: $scope.hintList[selected[0]]
                    };
                }
                return selected;
            }
            function deselectSelectedListItems() {
                let selected;
                for (let p = 0, plen = $scope.hintList.length; p < plen; p++) {
                    for (let v = 0, vlen = $scope.hintList[p].value.length; v < vlen; v++) {
                        if ($scope.hintList[p].value[v].selected) {
                            selected = [p, v];
                        }
                        if (selected) {
                            break; // stop loop if found something selected
                        }
                    }
                    if (selected) {
                        break; // stop parent loop if found something selected
                    }
                }
                if (selected) {
                    $scope.hintList[selected[0]].value[selected[1]].selected = false;
                }
            }
            function resetDefaultFilterList() {
                $scope.filterListCount = 0;
                $scope.filterList = {
                    include: [],
                    exclude: []
                };
            }
            resetDefaultFilterList();
            // set previous input tokens for change refrence later
            let pInput = false, pTokens = [];
            function resetDefaultSearchInputs() {
                input.value = '';
                pInput = false, pTokens = [];
                $scope.inputChain = [];
                $scope.autocomplete = {
                    value: '',
                    title: ''
                }
                $scope.hintList = false;
            }
            resetDefaultSearchInputs();

            // function to display modifiers in the search bar
            $scope.modifierDisplay = function (item) {
                let itemClass;
                if (item.type === 'text') {
                    itemClass = '';
                } else if (item.completed) {
                    itemClass = 'modifier';
                } else {
                    itemClass = 'modifier incomplete';
                }
                return itemClass;
            }

            // function to display prefix's in the search bar
            $scope.addSpace = function (item, index) {
                if (!pInput) { return ''} // do nothing if pInput is false
                // do nothing if the the item is at the end of the chain
                if (pInput[pInput.length-1].value === '') {
                    return ' ';
                } else if (index === (pInput.length-1)) {
                    return ''
                } else if ((item.type === 'text') || (item.completed)) {
                    // add space if there is no type defined or item is completed
                    return ' ';
                } else {
                    return '';
                }
            }

            // these can only be used once
            let availableModifiers = [
                {
                    key: 'include',
                    value: 'is:',
                    tip: 'a value',
                },{
                    key: 'exclude',
                    value: 'not:',
                    tip: 'a value',
                },{
                    key: 'include',
                    value: 'include:',
                    tip: 'a value',
                }, {
                    key: 'exclude',
                    value: 'exclude:',
                    tip: 'a value',
                },
            ];
            let optionalModifiers = [{
                key: 'from',
                value: 'from:',
                tip: 'a category or column'
            }]

            let allModifiers = _.concat(availableModifiers, optionalModifiers); // since nothing is set yet, lets concat the available modifiers with optional ones

            // ELEMENT HELPERS
            // stop up, down, and tab from acting on input box
            input.addEventListener('keydown', function (e) {
                switch(e.keyCode) {
                    case keys.up:
                    case keys.down:
                    case keys.tab:
                        e.preventDefault();
                    break;
                }
            })
            function hasClass(el, name, callback) {
                let result = false;
                if (el.classList) {
                    result = el.classList.contains(name);
                } else {
                    result = new RegExp('(^| )' + name + '( |$)', 'gi').test(el.className);
                }
                return callback(result);
            }
            function addClass(el, name) {
                if (el.classList) {
                    el.classList.add(name);
                } else {
                    el.className += ' ' + name;
                }
                return;
            }
            function removeClass(el, name) {
                if (el.classList) {
                    el.classList.remove(name);
                } else {
                    el.className = el.className.replace(new RegExp('(^|\\b)' + name.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }

            function checkIfModifier(string) {
                let modifier = false;
                // loop through modifier list to see if the string starts with any of its values
                for (let m = 0, mlen = allModifiers.length; m < mlen; m++) {
                    if (_.startsWith(string.toLowerCase(), allModifiers[m].value)) {
                        modifier = allModifiers[m];
                        break; // stop loop if found a match
                    }
                }
                return modifier;
            }

            function injectIntoArray(arr, index, obj) {
                // take section in front of index
                let leftSide = _.take(arr, index);
                let rightSide = _.takeRight(arr, (arr.length-index));
                // push new obj to the end of the left side
                if (_.isArray(obj)) {
                    for (let o = 0, olen = obj.length; o < olen; o++) {
                        leftSide.push(obj[o]);
                    }
                } else {
                    leftSide.push(obj);
                }
                // concat sides
                return _.concat(leftSide, rightSide);
            }

            function removeFromArray(arr, start, end) {
                let leftSide = _.take(arr, start);
                let rightSide = _.takeRight(arr, (arr.length-(end+1)));
                return _.concat(leftSide, rightSide);
            }

            /////////////////////////////
            /// FILTER LIST MODIFIERS ///
            /////////////////////////////
            function addToFilterList(action, value, column, columnTitle) {
                // clear the pInput
                resetDefaultSearchInputs();
                // check to see if the fitler already exists in the chain
                let matching = $scope.filterList[action].filter(function (f) { return ((f.value === value) && (f.from === column)) })
                if (matching.length > 0) { return } // do nothing if there are identical items
                $scope.filterListCount++;
                if (action === 'exclude') {
                    $scope.filterList.exclude.push({value: value, from: column, title: columnTitle});
                } else {
                    $scope.filterList.include.push({value: value, from: column, title: columnTitle});
                }
                $scope.main.addFilter(column, value, action, false, columnTitle);
                $scope.main.runFilters();
                if ($state.current.name === 'pages.main.search') {
                    $scope.$broadcast('runSearch');
                } else if ($state.current.name === 'pages.main.lateral_map') {
                    $scope.main.runLatFilters($scope.filterList);
                }
            }
            $scope.removeFilter = function (action, index) {
                let item = angular.copy($scope.filterList[action][index])
                $scope.main.removeFilter(item.from, item.value, action, false, item.columnTitle);
                // remove item from the filter list when X is clicked in dropdown
                $scope.filterList[action].splice(index, 1);
                $scope.filterListCount--;
                $scope.main.runFilters();
                if ($state.current.name === 'pages.main.search') {
                    $scope.$broadcast('runSearch');
                } else if ($state.current.name === 'pages.main.lateral_map') {
                    $scope.main.runLatFilters($scope.filterList);
                }
            }
            function addToFIlterListFromChain(chain) {
                let queryString = "", modifier = 'include', column = 'all', columnTitle; // set defaults for filter insert
                let obj = {};
                chain.forEach(function (c) {
                    if (!obj.hasOwnProperty(c.type)) {
                        obj[c.type] = '';
                    }
                    obj[c.type] += c.value+' ';
                })
                for (let i in obj) {
                    switch(i) {
                        case 'from':
                            // strip the 'from:' from the value
                            let col = _.trimStart(obj[i].toLowerCase(), 'from:');
                            col = _.trim(col); // remove any spaces in begining or end
                            // loop through columns and find a match
                            for (let s in $scope.main.searchCategories) {
                                if ($scope.main.searchCategories[s].toLowerCase() === col) {
                                    column = s;
                                    columnTitle = $scope.main.searchCategories[s];
                                    break;
                                }
                            }
                        break;
                        case 'include':
                            if (_.startsWith(obj[i].toLowerCase(), 'is:')) {
                                obj[i] = obj[i].substring('is:'.length);
                            }
                            if (_.startsWith(obj[i].toLowerCase(), 'include:')) {
                                obj[i] = obj[i].substring('include:'.length);
                            }
                            obj[i] = _.trim(obj[i]); // trim any white space
                            queryString = obj[i];
                            modifier = 'include';
                        break;
                        case 'exclude':
                            if (_.startsWith(obj[i].toLowerCase(), 'not:')) {
                                obj[i] = obj[i].substring('not:'.length);
                            }
                            if (_.startsWith(obj[i].toLowerCase(), 'exclude:')) {
                                obj[i] = obj[i].substring('exclude:'.length);
                            }
                            obj[i] = _.trim(obj[i]); // trim any white space
                            queryString = obj[i];
                            modifier = 'exclude';
                        break;
                        case 'text':
                            obj[i] = _.trim(obj[i]); // trim any white space
                            queryString = obj[i];
                        break;
                    }
                }
                addToFilterList(modifier, queryString, column, columnTitle);
            }

            // listen for incoming filter events from main controller
            $scope.$on('addSearchBarItem', function (event, column, value, action, columnTitle) {
                // note this is a call coming externally. the item has already been added to the data model
                // we just need to add it to our dropdown
                $scope.filterListCount++; // increase the count
                $scope.filterList[action].push({value: value, from: column, title: columnTitle}); // push to filter list
            })

            $scope.$on('removeSearchBarItem', function (event, column, value, action, columnTitle) {
                // addToFilterList(action, value, column, columnTitle);
                // we have to check if the value exists in our filter list by looping through
                for (let f = 0, flen = $scope.filterList[action].length; f < flen; f++) {
                    if (($scope.filterList[action][f].from === column) && ($scope.filterList[action][f].value.toLowerCase() === value.toLowerCase())) {
                        $scope.removeFilter(action, f);
                        break; // stop loop
                    }
                }
            })

            $scope.$on('clearAllFilters', function () {
                $scope.removeAllFilters();
            })

            // helper for converting our pInput array to the format read by the hightlight loop in the view
            function convertTokensToChain(inputs) {
                let arr = []; // this is going to act as our new list
                for (let i = 0, len = inputs.length; i < len; i++) {
                    let input = inputs[i];
                    if (input.type === 'text') {
                        arr.push({
                            type: input.type,
                            completed: input.completed,
                            value: input.value
                        });
                    } else {
                        if (arr.length > 0) {
                            // if it shares the same type as the incomplete one stored before..
                            // check if it has the same type AND completedness of the item before
                            if ((arr[arr.length-1].type === input.type) && (arr[arr.length-1].completed === input.completed)) {
                                arr[arr.length-1].value = arr[arr.length-1].value+' '+input.value; // append the value to the previous
                            } else { // this shouldent ever run
                                arr.push({
                                    type: input.type,
                                    completed: input.completed,
                                    value: input.value
                                });
                            }
                        } else {
                            // this is the first incomplete item in the chain.. just push it as so
                            arr.push({
                                type: input.type,
                                completed: input.completed,
                                value: input.value
                            });
                        }
                    }
                }
                return arr;
            }
            // this function takes an array and displays the items in the dropdown below the search
            function displayDropdown(arr) {
                // as we filter, some categories' values will become empty arrays.. dont push those
                let list = arr.filter(function (d) {
                    return (d.value.length > 0);
                })
                $scope.hintList = list; // assign the list to the dropdown
                // if there is nothing in the list, hide the dropdown
                if (list.length === 0) {
                    addClass(hintMenu, 'hidden');
                } else {
                    removeClass(hintMenu, 'hidden');
                }
                return;
            }

            // taking in a string, item array and the input field. this function should return
            // the index of what item is currently being modified
            function getCurrentWordIndex(arr, string, input) {
                /*
                ** Returns the caret (cursor) position of the specified text field.
                ** Return value range is 0-oField.value.length.
                */
                function doGetCaretPosition(oField) {
                  // Initialize
                  var iCaretPos = 0;
                  // IE Support
                    if (document.selection) {
                        // Set focus on the element
                        oField.focus();
                        // To get cursor position, get empty selection range
                        var oSel = document.selection.createRange();
                        // Move selection start to 0 position
                        oSel.moveStart('character', -oField.value.length);
                        // The caret position is selection length
                        iCaretPos = oSel.text.length;
                    }
                    // Firefox support
                    else if (oField.selectionStart || oField.selectionStart == '0') {
                        iCaretPos = oField.selectionStart;
                    }
                    // Return results
                    return iCaretPos;
                }
                let inputPosition = doGetCaretPosition(input); // get input position
                let s = string.substring(0, inputPosition); // truncate the string into our new variable s
                // s = _.trimEnd(s); // remove any space at the end of the string that may insterfere with the split below
                let a = s.split(' '); // split our string into an array seperated by spaces
                // because the pInput array is 1:1 the length of the individual words in the input box...
                // the last position in the a array should tell us which pInput item is being modified.
                // the index to return should be the last item (?)
                return (a.length-1);
            }

            function autocomplete(typed, list, tokens) {
                function setAutocompleteValue(value, title) {
                    if (!value) {
                        $scope.autocomplete.title = '';
                        $scope.autocomplete.value = '';
                    } else {
                        $scope.autocomplete.value = value;
                        $scope.autocomplete.title = title; // this value is so we know what the title looks like (where the caps are) if the user tab-completes
                    }
                }
                if (!typed) {
                    setAutocompleteValue(false);
                } else if (list.length > 0) {
                    if (list[0].value.length > 0) {
                        let match = list[0].value[0];
                        if (_.startsWith(match.value.toLowerCase(), typed.toLowerCase())) {
                            let count = typed.length;
                            // if the last items in tokens array is an empty string, there is a space present
                            if (tokens[tokens.length-1] === '') {
                                setAutocompleteValue(_.trimStart(match.value.substr(count, match.value.length-1), match.value));
                            } else {
                                setAutocompleteValue(match.value.substr(count, match.value.length-1), match.value);
                            }
                        } else {
                            setAutocompleteValue(false);
                        }
                    } else {
                        setAutocompleteValue(false);
                    }
                } else {
                    setAutocompleteValue(false);
                }
            }

            function getMatchingTextString(arr, indexes) {
                // assuming the index's are in ascending order. start a loop at the begining
                let string = '';
                for (let i = indexes[0]; i <= indexes[indexes.length-1]; i++) {
                    string += arr[i].value;
                    if (i !== (indexes.length-1)) {
                        string += ' '; // attach space to every word until the end
                    }
                }
                // take the string and strip any modifiers off the front if they exist
                allModifiers.forEach(function (m) {
                    if (_.startsWith(string, m.value)) {
                        // if the string starts with any of the modifier values, trim it off and strip any spaces
                        string = _.trimStart(string, m.value);
                        // now trim any whitespace
                        string = _.trimStart(string);
                    }
                })
                return string;
            }

            // input pInout array and current obj and get back array of matching group items
            function getMatchingGroupIndexs(arr, current, index, callback) {
                let left = [], right = [];
                for (let i = index; i >= 0; i--) {
                    if (typeof arr[i] === 'undefined') { continue } // do noghting if there is a miscount of indexes
                    if ((current.completed === arr[i].completed) && (current.type === arr[i].type)) {
                        left.push(i);
                    } else {
                        break; // end loop if the next item does not match
                    }
                }
                left = _.reverse(left);
                for (let i = index+1, len = arr.length; i < len; i++) {
                    if (typeof arr[i] === 'undefined') { continue } // do noghting if there is a miscount of indexes
                    if ((current.completed === arr[i].completed) && (current.type === arr[i].type)) {
                        // note: there shouldent be a modifier here because we are moving somewhere after the first defining value
                        right.push(i);
                    } else {
                        break; // end the loop
                    }
                }
                let concat = _.concat(left, right); // bring left and right sides together
                return callback(concat);
            }

            /*
             * This accepts pInput, modifies values and returns new pInput array to be saved
             * @param  {Array}  arr      [Original pInput array]
             * @param  {Array}  indexes  [Array of indexes to change in pInput - ASCENDING]
             * @param  {Array}  toChange [Array of objects containing keys with new values to change]
             * @return {Array}  callback [New array to replace the pInput that was originally inserted]
             */
            function changeGroupStatus(arr, indexes, toChange, callback) {
                // loop through the indexes to change
                for (let i = indexes[0]; i <= indexes[indexes.length-1]; i++) {
                    // loop through the list of changes to make
                    for (let c = 0, clen = toChange.length; c < clen; c++) {
                        arr[i][toChange[c].key] = toChange[c].value;
                    }
                }
                return callback(arr);
            }

            // check what element of pInput does not match tokens. return the index and value of the changed item
            function isChanged(arr, tokens, callback) {
                let changed = false;
                for (let p = 0, plen = arr.length; p < plen; p++) {
                    if ((arr[p].value !== tokens[p]) && (typeof tokens[p] !== 'undefined')) {
                        changed = {
                            index: p,
                            value: tokens[p]
                        }
                        break;
                    }
                }
                return callback(changed);
            }

            ////////////////////
            ///// INPUT BOX ////
            ////////////////////
            function inputRun(event) {
                let list = [];
                function sendToList(arr, title, key) {
                    // sort columns before sending it
                    arr.sort(function (a,b) {
                        if (a.title < b.title) return -1;
                        if (a.title > b.title) return 1;
                        return 0;
                    })
                    if (arr.length > 0) {
                        list.push({
                            key: key,
                            title: title,
                            value: arr
                        })
                    }
                }
                function dropdownFilter(type, term) {
                    let arr;
                    switch(type) {
                        case '+':
                            let followingText = _.trimStart(term, '+'); // trim '+' from the start of the input string
                            arr = allModifiers.filter(function (item, index) {
                                let result = false;
                                if (followingText === '')  {
                                    result = true;
                                } else if (item.value.indexOf(followingText.toLowerCase()) !== -1) {
                                    result = true;
                                } else {
                                    result = false
                                }
                                return result;
                            })
                            sendToList(arr, 'Modifiers', 'modifiers'); // push modifiers to list
                        case 'modifiers':
                            if (!term) {
                                arr = allModifiers;
                            } else {
                                arr = allModifiers.filter(function (item, index) {
                                    let result = false;
                                    if (item.value.indexOf(term.toLowerCase()) !== -1) {
                                        result = true;
                                    }
                                    return result;
                                })
                            }
                            return sendToList(arr, 'Modifiers', 'modifiers'); // push modifiers to list
                        break;
                        case 'columns':
                            arr = [];
                            // loop through available categories and push the matching ones
                            for (let c in $scope.main.searchCategories) {
                                if (!term) {
                                    arr.push({
                                        key: c,
                                        value: $scope.main.searchCategories[c],
                                        selected: false // value for highlighting style upon arrow up/down
                                    })
                                } else {
                                    if ($scope.main.searchCategories[c].toLowerCase().indexOf(term.toLowerCase()) !== -1) {
                                        arr.push({
                                            key: c,
                                            value: $scope.main.searchCategories[c],
                                            selected: false // value for highlighting style upon arrow up/down
                                        })
                                    }
                                }
                            }
                            return sendToList(arr, 'Columns', 'columns'); // send it to the list
                        break;
                    }
                }
                function handleModifierDropdown(changed, type, list) {
                    switch(type) {
                        case 'from':
                            if (changed.value === 'from:') {
                                // loop through available categories and push the matching one
                                dropdownFilter('columns', false);
                            } else {
                                // get matching indexes of changed item
                                getMatchingGroupIndexs(pInput, pInput[changed.index], changed.index, function (matchingIndexes) {
                                    // with the matching index(s) get the full string match
                                    let fullString = getMatchingTextString(pInput, matchingIndexes);
                                    dropdownFilter('columns', fullString);
                                    autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
                                })
                            }
                        break;
                    }
                    displayDropdown(list);
                }

                // default variables
                let text = input.value;
                let tokens = _.split(text, ' ');
                // capture inputs
                let key = event.keyCode;

                // do nothing if shift, alt, or control were pressed on the keyboard
                if ((key === keys.ctrl) || (key === keys.shift) || (key === keys.shift) || (key === keys.alt)) { return }
                // NOTHING SET
                if (text === '') { //if no text
                    $scope.hintList = false; // reset the hint list
                    pInput = false;
                    $scope.inputChain = convertTokensToChain(pInput);
                    autocomplete(false);
                    return // stop analysis here
                }

                switch(key) {
                    case keys.tab:
                        let cIndex = getCurrentWordIndex(pInput, text, input);
                        let curr = pInput[cIndex]; // current item in the pInput
                        // if theres no autocomplete value, set the
                        if (($scope.autocomplete.value === '') && (!curr.completed)) {
                            getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
                                // update all matching items in local group to completed
                                changeGroupStatus(pInput, matchingIndexes, [{key: 'completed', value: true }], function (newInputArray) {
                                    // update pInput to the new returned array
                                    pInput = newInputArray;
                                })
                            })
                        } else {
                            // check to see if the autocompleted value is a match to any modifiers
                            let modifierMatch = false;
                            for (let m = 0, mlen = allModifiers.length; m < mlen; m++) {
                                if (angular.copy($scope.autocomplete.title) === allModifiers[m].value) {
                                    // it is a modifier. set current group to the type
                                    modifierMatch = allModifiers[m]; // replace our match variable with the matched modifier
                                    break; // stop loop
                                }
                            }
                            if (modifierMatch) {
                                getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
                                    // update all matching items in local group to completed
                                    changeGroupStatus(pInput, matchingIndexes, [{key: 'completed', value: false }, {key: 'type', value: modifierMatch.key}], function (newInputArray) {
                                        pInput = newInputArray; // replace pInput
                                        // still have to update token list
                                        // INPUT TEXT
                                        tokens[matchingIndexes[0]] = modifierMatch.value;
                                        input.value = _.join(tokens, ' '); // update input text
                                        // PINPUT SETTING
                                        pInput[matchingIndexes[0]].value = modifierMatch.value;
                                        autocomplete(false);
                                    })
                                })
                            } else {
                                // get the indexes of all indexs in this current grouping
                                getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
                                    let toInjectString = '', toInjectArr = [], index = matchingIndexes[0]; // set up string to be injected into the input box
                                    if (curr.type === 'from') {
                                        toInjectString = 'from: '+angular.copy($scope.autocomplete.title);
                                        let a = toInjectString.split(' ');
                                        for (let v = 0, vlen = a.length; v < vlen; v++) {
                                            toInjectArr.push({
                                                completed: true,
                                                type: 'from',
                                                value: a[v]
                                            })
                                            index++;
                                        }
                                    } else {
                                        toInjectString = angular.copy($scope.autocomplete.title);
                                        let a = toInjectString.split(' ');
                                        for (let v = 0, vlen = a.length; v < vlen; v++) {
                                            toInjectArr.push({
                                                completed: true,
                                                type: 'text',
                                                value: a[v]
                                            })
                                            index++;
                                        }
                                    }
                                    // INPUT TEXT
                                    tokens = removeFromArray(tokens, matchingIndexes[0], matchingIndexes[matchingIndexes.length-1]); // remove the edited block
                                    tokens = injectIntoArray(tokens, matchingIndexes[0], toInjectString); // split our new value and inject it
                                    let t = _.join(tokens, ' ');
                                    input.value = t;
                                    // pInput
                                    let p = removeFromArray(pInput, matchingIndexes[0], matchingIndexes[matchingIndexes.length-1]);
                                    pInput = injectIntoArray(p, matchingIndexes[0], toInjectArr); // split our new value and inject it

                                    // clear autocomplete
                                    deselectSelectedListItems();
                                    autocomplete(false);
                                })
                            }
                        }
                    break;
                    case keys.down:
                        if (!$scope.hintList) { return } // do nothing if dropdown does not exist
                        if ($scope.hintList.length === 0) { return } // do nothing if dropdown is empty
                        modHighlightPosition($scope.hintList, 'down', function (result) {
                            // set autocomplete to false
                            autocomplete(false);
                        })
                    break;
                    case keys.up:
                        if (!$scope.hintList) { return } // do nothing if dropdown does not exist
                        if ($scope.hintList.length === 0) { return } // do nothing if dropdown is empty
                        modHighlightPosition($scope.hintList, 'up', function (result) {
                            // set autocomplete to false
                            autocomplete(false);
                        })
                    break;
                    case keys.esc:
                        if (getSelectedListItem()) { // if there are any selected items.. deselect them
                            deselectSelectedListItems();
                        } else {
                            addClass(hintMenu, 'hidden'); // close menu
                        }
                    break;
                    case keys.enter:
                        if (!pInput) {
                            // theres no previous record so lets create one
                            let item = {
                                type: 'text',
                                value: text,
                                completed: null
                            }
                            pInput = [];
                            pInput.push(item);
                        }
                        let selected = getSelectedListItem();
                        let currentIndex = getCurrentWordIndex(pInput, text, input);
                        let current = pInput[currentIndex]; // current item in the pInput
                        if (!current) { return } // if all spaces are entered, current will appear undefined, sos do nothing
                        // if there is a selected item, replace current grouping with the completed block
                        if (!selected) { // if nothing is selected
                            if (current.completed || (current.type === 'text')) { // if item is completed or is text
                                // do nothing if the pInput does not contain a string item
                                let containsString = false;
                                for (let i = 0, len = pInput.length; i < len; i++) {
                                    if (pInput[i].type !== 'from') { // if the item is not from
                                        let v = _.trim(pInput[i].value);
                                        if (v !== '') { // if the value is not an empty space
                                            containsString = true; // mark 'containsString' true and stop loop
                                            break;
                                        }
                                    }
                                }
                                if (!containsString) { return } // do nothing if pInput doesnt contain a string
                                addToFIlterListFromChain(pInput); // send to filter list conversion function to process the chain
                            } else {
                                // nothing needs to be replaced or modified except the pInputs of what i'm currenty on
                                if (current.type === 'text') { return } // do nothing if the type is just text
                                getMatchingGroupIndexs(pInput, current, currentIndex, function (matchingIndexes) {
                                    // update all matching items in local group to completed
                                    changeGroupStatus(pInput, matchingIndexes, [{key: 'completed', value: true }], function (newInputArray) {
                                        // update pInput to the new returned array
                                        pInput = newInputArray;
                                        autocomplete(false); // remove autocomplete if something was selected
                                    })
                                })
                            }
                        } else {
                            getMatchingGroupIndexs(pInput, current, currentIndex, function (matchingIndexes) {
                                // we should have a grouping array of items that are to be replaced
                                // break apart the selected value into an array to inject
                                let pInputInject, injectString, injectIndex = matchingIndexes[0]; // note the index is the first item in our replaced items
                                switch(selected.parent.key) {
                                    case 'columns': // columns always have the 'from:' prefix
                                        pInputInject = [];
                                        // set and push values to replace
                                        injectString = 'from: '+selected.item.value;
                                        let a = selected.item.value.split(' ');
                                        pInputInject.push({
                                            completed: true,
                                            type: 'from',
                                            value: 'from:'
                                        })
                                        injectIndex++;
                                        for (let v = 0, vlen = a.length; v < vlen; v++) {
                                            pInputInject.push({
                                                completed: true,
                                                type: 'from',
                                                value: a[v]
                                            })
                                            injectIndex++;
                                        }
                                    break;
                                    case 'modifiers': // modifiers will have varying prefix's
                                        injectString = selected.item.value;
                                        pInputInject = {
                                            completed: false,
                                            type: selected.item.key,
                                            value: selected.item.value
                                        }
                                    break;
                                }
                                // set the placeholders
                                // INPUT TEXT
                                tokens = removeFromArray(tokens, matchingIndexes[0], matchingIndexes[matchingIndexes.length-1]); // remove the edited block
                                tokens = injectIntoArray(tokens, matchingIndexes[0], injectString); // split our new value and inject it
                                input.value = _.join(tokens, ' '); // update input text
                                // PINPUT SETTING
                                let pi = removeFromArray(pInput, matchingIndexes[0], matchingIndexes[matchingIndexes.length-1]);
                                pInput = injectIntoArray(pi, matchingIndexes[0], pInputInject); // split our new value and inject it

                                // set ptokens length to monitor for changes
                                // clear autocomplete
                                deselectSelectedListItems();
                                autocomplete(false);
                            })
                        }
                    break;
                    // NOTE: THERE IS NO BREAK AFTER THIS CASE ON PURPOSE
                    case keys.back:
                        let ci = getCurrentWordIndex(pInput, text, input);
                        let c = pInput[ci]; // current item in the pInput
                        getMatchingGroupIndexs(pInput, c, ci, function (matchingIndexes) {
                            // if current item is complete change its group to incomplete status
                            if (c.completed) {
                                changeGroupStatus(pInput, matchingIndexes, [{key: 'completed', value: false }], function (newInputArray) {
                                    // update pInput to the new returned array
                                    pInput = newInputArray;
                                })
                            } else if (c.type !== 'text') {
                                // if the type is not text and incomplete, check the pInput of the first index to make sure
                                // the modifier is still complete. if not change the group type to text
                                let match = false;
                                for (let m = 0, mlen = allModifiers.length; m < mlen; m++) {
                                    if (_.startsWith(pInput[matchingIndexes[0]].value.toLowerCase(), allModifiers[m].value)) {
                                        match = true;
                                        break;
                                    }
                                }
                                // if there is no match.. change the type for all matching pInput items
                                // also make completed status null
                                if (!match) {
                                    changeGroupStatus(pInput, matchingIndexes, [
                                        {
                                            key: 'type',
                                            value: 'text'
                                        },
                                        {
                                            key: 'completed',
                                            value: null
                                        }
                                    ], function (newInputArray) {
                                        // update pInput to the new returned array
                                        pInput = newInputArray;
                                    })
                                }
                            }
                        })
                    default:
                        if (!pInput) {
                            // theres no previous record so lets create one
                            let item = {
                                type: 'text',
                                value: text,
                                completed: null
                            }
                            pInput = [];
                            pInput.push(item);
                            // show modifier dropdown if + is typed
                            if (text === '+') {
                                // now construct list with matching items
                                sendToList(allModifiers, 'Modifiers', 'modifiers'); // push all modifiers to list
                                displayDropdown(list);
                            } else {
                                dropdownFilter('modifiers', text);
                                dropdownFilter('columns', text);
                                displayDropdown(list);
                            }
                        } else {
                            if (tokens.length > pTokens) {
                                // there has been a new word added into the tokens array
                                // find its location and inject it into the pTokens
                                isChanged(pInput, tokens, function (changed) {
                                    if (changed) { // this means that a value was not added at the end
                                        // we have the index of the new value
                                        // extract the other settings from the items in front to determine its settings
                                        let item = {
                                            type: pInput[changed.index].type,
                                            value: changed.value,
                                            completed: pInput[changed.index].completed
                                        }
                                        // if there is a value in front of this (and there MAY OR MAY NOT BE)
                                        // we need to subrtact our new character(s) from the previous and next depending where the space was placed
                                        if (typeof pInput[changed.index] !== 'undefined') { // this is the spot currently before we push new data in
                                            if (_.startsWith(pInput[changed.index].value, changed.value)) {
                                                pInput[changed.index].value = _.trimStart(pInput[changed.index].value, changed.value)
                                            }
                                        }
                                        // if the new item is not at the begining so we need to inherit some new values from the previous record
                                        let previous = pInput[changed.index-1];
                                        if (typeof previous !== 'undefined') {
                                            if (typeof pInput[previous.index] !== 'undefined') { // this is the spot currently before we push new data in
                                                if (_.endsWith(pInput[previous.index].value, changed.value)) {
                                                    pInput[previous.index].value = _.trimEnd(pInput[previous.index].value, changed.value)
                                                }
                                            }
                                        }
                                        // now push the new value in
                                        pInput = injectIntoArray(pInput, changed.index, item);
                                    } else { // value added at the end
                                        // we have to check the context of the previous to see what to do
                                        let changedIndex = (pInput.length-1), item;
                                        if (pInput[changedIndex].completed) {
                                            item = {
                                                type: 'text',
                                                value: tokens[tokens.length-1],
                                                completed: false
                                            }
                                        } else {
                                            item = {
                                                type: pInput[changedIndex].type,
                                                value: tokens[tokens.length-1],
                                                completed: pInput[changedIndex].completed
                                            }
                                        }
                                        // if there is a value in front of this (and there MAY OR MAY NOT BE)
                                        // we need to subrtact our new character(s) from the previous and next depending where the space was placed
                                        if (typeof pInput[changedIndex] !== 'undefined') { // this is the spot currently before we push new data in
                                            if (_.endsWith(pInput[changedIndex].value, tokens[tokens.length-1])) {
                                                pInput[changedIndex].value = _.trimEnd(pInput[changedIndex].value, tokens[tokens.length-1])
                                            }
                                        }
                                        pInput.push(item); // simply push the new record in
                                        autocomplete(false);
                                        // add autocomplete to the added item
                                        getMatchingGroupIndexs(pInput, item, tokens.length-1, function (matchingIndexes) {
                                            // with the matching index(s) get the full string match
                                            let fullString = getMatchingTextString(pInput, matchingIndexes);
                                            if (item.type === 'from') {
                                                dropdownFilter('columns', fullString);
                                            }
                                            autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
                                        })
                                    }
                                })
                            } else if (tokens.length < pTokens) { // item has been removed (probably from backspacing)
                                // token count is not a match
                                // find change and remove it
                                isChanged(pInput, tokens, function (changed) {
                                    if (changed) { // something was removed from within the chain and not the end
                                        pInput.splice(changed.index, 1);
                                    } else { // something was removed from the end of the chain
                                        pInput.splice((pInput.length-1), 1);
                                    }
                                })
                            } else {
                                // something has been modified - BY ADDING TEXT
                                // look for item that does not match
                                isChanged(pInput, tokens, function (changed) {
                                    if (!changed) { return } // do nothing if nothing changed
                                    // destroy the autocomplete if it exists
                                    autocomplete(false);
                                    pInput[changed.index].value = changed.value;
                                    // TODO !!! - set the all param
                                    // determine what to set with the settings
                                    // check to see what modifier (if any has been applied)
                                    let isModifier = checkIfModifier(changed.value);
                                    if (isModifier) {
                                        pInput[changed.index].type = isModifier.key;
                                        pInput[changed.index].completed = false;
                                        handleModifierDropdown(changed, isModifier.key, list);
                                    } else if (_.startsWith(changed.value, '+')) {
                                        dropdownFilter('+', changed.value);
                                        displayDropdown(list);
                                    } else {
                                        let current = pInput[changed.index];
                                        // filter down search here
                                        if (current.type === 'text') {
                                            // get matching indexes of current item
                                            getMatchingGroupIndexs(pInput, current, changed.index, function (matchingIndexes) {
                                                // get full text string from matching indexes
                                                let fullString = getMatchingTextString(pInput, matchingIndexes);
                                                dropdownFilter('modifiers', fullString);
                                                dropdownFilter('columns', fullString);
                                                autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
                                            })
                                        } else if (!current.completed) {
                                            // get matching indexes of changed item
                                            getMatchingGroupIndexs(pInput, current, changed.index, function (matchingIndexes) {
                                                // with the matching index(s) get the full string match
                                                let fullString = getMatchingTextString(pInput, matchingIndexes);
                                                // now that we have our string. begin to filter down optional modifiers
                                                if (current.type === 'from') {
                                                    dropdownFilter('columns', fullString);
                                                    autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
                                                }
                                            })
                                        }
                                        displayDropdown(list);
                                    }
                                })
                            }
                        }
                    break // end default block
                }
                // set the pTokens count to keep track of what changed
                pTokens = tokens.length;
                $scope.inputChain = convertTokensToChain(pInput); // update input chain
            }
            // upon input focus check for mode and
            $scope.inputFocus = function (evt) {
                addClass(filtersMenu, 'hidden');
                // remove hidden class on hintMenu
                removeClass(hintMenu, 'hidden');
            }
            // actions to perform on input deselect
            $scope.inputBlur = function (evt) {
                // close hintMenu on blur
                addClass(hintMenu, 'hidden');
            }
            // TYPING ACTIONS
            $scope.inputChange = function (event) {
                inputRun(event);
            }
            // Removes ALL the filters
            $scope.removeAllFilters = function () {
                if ($state.current.name === 'pages.main.search') {
                    resetDefaultSearchInputs();
                    resetDefaultFilterList();
                    $scope.$broadcast('runSearch');
                } else if ($state.current.name === 'pages.main.lateral_map') {
                    resetDefaultSearchInputs();
                    resetDefaultFilterList();
                    // $scope.main.runLatFilters($scope.filterList);
                } else {
                    let params = angular.copy($scope.filterList);
                    for (let i = 0, flen = $scope.filterList["include"].length; i < flen; i++) {
                        $scope.main.removeFilter(params["include"][i].from, params["include"][i].value, "include", false, params["include"][i].title);
                    }
                    for (let e = 0, flen = $scope.filterList["exclude"].length; e < flen; e++) {
                        $scope.main.removeFilter(params["exclude"][e].from, params["exclude"][e].value, "exclude", false, params["exclude"][e].title);
                    }
                    $scope.main.runFilters();
                    resetDefaultSearchInputs();
                    resetDefaultFilterList();
                }
            }

            ///////////////////////////
            ///// FILTER DROPDOWN /////
            ///////////////////////////
            // filter dropdown click
            $scope.filterDropdownClick = function (evt) {
                hasClass(filtersMenu, 'hidden', function (exists) {
                    if (exists) {
                        removeClass(filtersMenu, 'hidden');
                    } else {
                        addClass(filtersMenu, 'hidden');
                    }
                })
            }
            $scope.searchBtnMouseover = function (evt) {
                // hide filter dropdown
                hasClass(filtersMenu, 'hidden', function (exists) {
                    if (!exists) {
                        addClass(filtersMenu, 'hidden');
                    }
                })
            }
            // filter dropdown deselecting
            document.addEventListener('mouseup', function (event) {
                // dont close if it has the class 'hint-menu'
                hasClass(event.target, 'hint-menu', function (exists) {
                    if (!exists) {
                        addClass(filtersMenu, 'hidden');
                    }
                })
                // dont close if it has the class 'remove_item'
                hasClass(event.target, 'remove_item', function (exists) {
                    if (exists) {
                        removeClass(filtersMenu, 'hidden');
                    }
                })
            })

            ///////////////////////
            /// SEARCH FUNCTION ///
            ///////////////////////

            $scope.runSearch = function () {
                // if we're on the search page already
                // if ($state.current.name === 'pages.main.search') {
                //     // not sure what to do here
                // } else {
                // otherwise lets transition to the search page
                    // let params = angular.copy($scope.filterList); // current filter params get sent to the params obj
                    // params.time = null;
                    // if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
                    //     params.time = {
                    //         start: $location.$$search.start,
                    //         end: $location.$$search.end
                    //     }
                    // }
                    // $state.go('pages.main.search', params);
                // }
                $scope.$broadcast('runSearch');
            }

            // made it broadcast so it can be called from main
            $scope.$on('runSearch', function (event, toState) {
                let params = angular.copy($scope.filterList); // current filter params get sent to the params obj
                params.time = null;
                if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
                    params.time = {
                        start: $location.$$search.start,
                        end: $location.$$search.end
                    }
                }
                $state.go('pages.main.search', params);
            })

            // set filter name for styling of filter button depending on current page
            $scope.statename = angular.copy($state.current.name);
            // cleanup when pages are changed
            $rootScope.$on('$stateChangeStart', function (event, toState) {
                $scope.statename = toState.name; // change statename with state change
                resetDefaultFilterList();
                resetDefaultSearchInputs();
            })
        }
    }
}

directive.$inject = ['generateId', '$stateParams', '$rootScope', '$location', 'usSpinnerService', '$state'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/searchbar/searchbar.js
 **/